var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0984 12.2517L11.6667 12.9167C9.34841 11.7534 7.91674 10.4167 7.08341 8.33341L7.72508 4.89175L6.51258 1.66675H3.38674C2.44674 1.66675 1.70674 2.44341 1.84758 3.37258C2.19758 5.69175 3.23091 9.89758 6.25008 12.9167C9.42091 16.0876 13.9884 17.4634 16.5017 18.0109C17.4726 18.2217 18.3334 17.4651 18.3334 16.4709V13.4842L15.0984 12.2517Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.edb16506ef42e13f9462e0a55d73c91d.svg";
export { ForwardRef as ReactComponent };